import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Row, Col, Tab, Nav } from 'react-bootstrap';
import moment from 'moment';
import { useSetTab } from '../../services/hooks';

import { CompactCard } from '../../components';
import { camelCaseEmptyStringRecursive } from '../../services/utils';
import { HRPermissionsRequest } from '../../requests/dashboards';
import PermissionDataTable from '../Shared/Permission/PermissionDataTable';
import VacationDataTable from '../Shared/Vacation/VacationDataTable';
import columns from '../Shared/Permission/approveColumns';
import adminDaysColumns from '../Shared/Permission/adminDaysColumns';

const PermissionIndex = ({ moreData, setMoreData, todayMoment = null, twoMonthsAgo = null }) => {
  const location = useLocation();
  const [key, setKey] = useSetTab('permissions', location);
  const [cards, setCards] = useState({});
  const [customParams, setCustomParams] = useState({});
  const [activeCard, setActiveCard] = useState('all');
  const [defaultStartDate, setDefaultStartDate] = useState(twoMonthsAgo);
  const [defaultEndDate, setDefaultEndDate] = useState(todayMoment);
  const dispatch = useDispatch();

  const fetchDashboardCards = () => {
    const request = async () => {
      HRPermissionsRequest({
        dispatch,
        successCallback: response => setCards(camelCaseEmptyStringRecursive(response.data))
      });
    };
    request();
  };

  const handleClick = card => {
    if (card !== 'administrative') {
      setKey('permissions');
    }
    switch (card) {
      case 'pending':
        setCustomParams({ status: 'pending' });
        setActiveCard('pending');
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(moment());
        break;
      case 'approved':
        setCustomParams({ status: 'approved' });
        setActiveCard('approved');
        setDefaultStartDate(moment().startOf('year'));
        setDefaultEndDate(moment().endOf('year'));
        break;
      case 'rejected':
        setCustomParams({ status: 'rejected' });
        setActiveCard('rejected');
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(moment());
        break;
      case 'administrative':
        setCustomParams({});
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(moment());
        setKey('administrative');
        setActiveCard('administrative');
        break;
      default:
        setCustomParams({});
        setActiveCard('all');
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(moment());
        break;
    }
    setMoreData(!moreData);
  };

  useEffect(fetchDashboardCards, [moreData]);

  return (
    <>
      <Row className="mt-4 mb-3">
        <Col md={3} xs={12}>
          <CompactCard
            variant="info-grey"
            title={cards.all}
            label="Solicitados"
            subtitle="Permisos solicitados"
            active={activeCard === 'all'}
            onClick={() => handleClick('all')}
          />
        </Col>
        <Col md={3} xs={12}>
          <CompactCard
            variant="warning"
            title={cards.pending}
            label="Por Autorizar"
            subtitle="Permisos por autorizar"
            active={activeCard === 'pending'}
            onClick={() => handleClick('pending')}
          />
        </Col>
        <Col md={3} xs={12}>
          <CompactCard
            variant="danger"
            title={cards.rejected}
            label="Rechazados"
            subtitle="Permisos rechazados"
            active={activeCard === 'rejected'}
            onClick={() => handleClick('rejected')}
          />
        </Col>
        <Col md={3} xs={12}>
          <CompactCard
            variant="primary"
            title={cards.approvedThisYear}
            label="Aprobados este año"
            subtitle="Permisos Aprobados"
            active={activeCard === 'approved'}
            onClick={() => handleClick('approved')}
          />
        </Col>
        <Col md={3} xs={12}>
          <CompactCard
            variant="info-grey"
            title={cards.admDays}
            label="Días Administrativos"
            subtitle="Permisos Días Administrativos"
            active={activeCard === 'administrative'}
            onClick={() => handleClick('administrative')}
          />
        </Col>
      </Row>
      <Tab.Container id="permissions-datatable.tabs" activeKey={key} mountOnEnter onSelect={k => setKey(k)}>
        <Nav variant="pills" className="ab-pills">
          <Nav.Item>
            <Nav.Link eventKey="permissions">Permisos</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="administrative">Días Administrativos</Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="permissions">
            <PermissionDataTable
              moreData={moreData}
              setMoreData={setMoreData}
              columns={columns}
              customParams={customParams}
              defaultStartDate={defaultStartDate}
              defaultEndDate={defaultEndDate}
            />
          </Tab.Pane>
          <Tab.Pane eventKey="administrative">
            <VacationDataTable
              columns={adminDaysColumns}
              moreData={moreData}
              setMoreData={setMoreData}
              withImport
              preName="administrative_days"
              customParams={{ filter_vacation_type: 'administrative_days, administrative_days_openning_balance' }}
              defaultStartDate={defaultStartDate}
              defaultEndDate={defaultEndDate}
            />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </>
  );
};

export default PermissionIndex;
